import _toConsumableArray from "/opt/github/_work/frontend-website-cms/frontend-website-cms/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import windowScrollTo from "./window-scroll";
export default function anchorScrollSpy() {
  var navigation = document.querySelector(".js-toc");

  if (navigation) {
    var TableOfContents = {
      container: navigation,
      links: null,
      headings: null,
      intersectionOptions: {
        rootMargin: "-50px 0px 0px 0px",
        threshold: 0.5
      },
      previousSection: null,
      observer: null,
      init: function init() {
        var _this = this;

        this.handleObserver = this.handleObserver.bind(this);
        this.setUpObserver();
        this.findLinksAndHeadings();
        this.observeSections();
        this.links.forEach(function (link) {
          link.addEventListener("click", _this.handleLinkClick.bind(_this));
        });
        var linkIndex = this.links.findIndex(function (link) {
          return link.href === document.location.href;
        });

        if (this.links && linkIndex > -1) {
          this.links[linkIndex].classList.add("is-visible", "is-active");
        }
      },
      handleLinkClick: function handleLinkClick(evt) {
        var id = evt.target.getAttribute("href").replace("#", "");
        var section = this.headings.find(function (heading) {
          return heading.getAttribute("id") === id;
        });

        if (!section) {
          return;
        }

        section.setAttribute("tabindex", -1);
        var customOffset = evt.target.getAttribute("data-custom-offset");

        if (!customOffset) {
          customOffset = 0;
        }

        var header = document.querySelector("header");
        header.classList.add("pointer-events-none");
        setTimeout(function () {
          header.classList.remove("pointer-events-none");
        }, 1000);
        windowScrollTo(section, customOffset);

        if (this.container.classList.contains("is-active")) {
          this.container.classList.remove("is-active");
        }

        evt.preventDefault();
      },
      handleObserver: function handleObserver(entries) {
        var _this2 = this;

        entries.forEach(function (entry) {
          var href = "#".concat(entry.target.getAttribute("id"));

          var link = _this2.links.find(function (l) {
            return l.getAttribute("href") === href;
          });

          if (entry.isIntersecting && entry.intersectionRatio <= 1) {
            link.classList.add("is-visible");
            _this2.previousSection = entry.target.getAttribute("id");
          } else {
            link.classList.remove("is-visible");
          }

          _this2.highlightFirstActive();
        });
      },
      highlightFirstActive: function highlightFirstActive() {
        var firstVisibleLink = this.container.querySelector(".is-visible");
        this.links.forEach(function (link) {
          link.classList.remove("is-active");
        });

        if (firstVisibleLink) {
          firstVisibleLink.classList.add("is-active");
        }

        if (!firstVisibleLink && this.previousSection) {
          this.container.querySelector("a[href=\"#".concat(this.previousSection, "\"]")).classList.add("is-active");
        }
      },
      observeSections: function observeSections() {
        var _this3 = this;

        this.headings.forEach(function (heading) {
          if (heading) {
            _this3.observer.observe(heading);
          }
        });
      },
      setUpObserver: function setUpObserver() {
        this.observer = new IntersectionObserver(this.handleObserver, this.intersectionOptions);
      },
      findLinksAndHeadings: function findLinksAndHeadings() {
        this.links = _toConsumableArray(this.container.querySelectorAll("a"));
        this.headings = this.links.map(function (link) {
          var id = link.getAttribute("href");
          var selector = null;

          try {
            selector = document.querySelector(id);
          } catch (err) {
            // eslint-disable-next-line no-console
            console.warn(err);
          }

          return selector;
        }).filter(function (link) {
          return link !== null;
        });
      }
    };
    TableOfContents.init();
  } // Scroll to section on load


  window.addEventListener("load", function () {
    if (window.location.hash) {
      var hash = window.location.hash;
      var section = document.querySelector(hash);

      if (section !== null) {
        windowScrollTo(section);
      }
    }
  });
}